const locationsTimezones = new Set([
    {
        name: 'America/New_York',
        offset: '-5:00',
        offsetNumber: -5
    },
    {
        name: 'America/Chicago',
        offset: '-6:00',
        offsetNumber: -6
    },
    {
        name: 'America/Denver',
        offset: '-7:00',
        offsetNumber: -7
    },
    {
        name: 'America/Los_Angeles',
        offset: '-8:00',
        offsetNumber: -8
    },
    {
        name: 'America/Nome',
        offset: '-9:00',
        offsetNumber: -9
    },
    {
        name: 'America/Adak',
        offset: '-10:00',
        offsetNumber: -10
    },
    {
        name: 'Pacific/Honolulu',
        offset: '-10:00',
        offsetNumber: -10
    },
    {
        name: 'America/Phoenix',
        offset: '-7:00',
        offsetNumber: -7
    }
]);

export default Array.from(locationsTimezones)